import { useQuery } from "@tanstack/react-query";
import { getMaterialListBySupplierCode } from "@/apis/supplier";

/**
 * 根据供应商编号及公司获取物料列表options
 * @param supplierCode
 * @param factoryValues
 * @returns
 */
export const useMaterialOptions = (
  supplierCode: string,
  factoryValues: string,
) => {
  const result = useQuery({
    queryKey: ["querySupplierCodeMaterialList", supplierCode, factoryValues],
    queryFn: () =>
      getMaterialListBySupplierCode({
        supplierCode,
        factoryValues,
      }),
    enabled: !!supplierCode && !!factoryValues,
  });

  const list = result.data?.data.data;

  const options = list?.map((m) => {
    return {
      label: m.materialName,
      value: m.id,
    };
  });

  return options;
};
